function test() {
    const datacollectionid = $('#page-type-identifier').attr('data-collection-id');
    if (datacollectionid === '7447483' || datacollectionid === '7447480' || datacollectionid === '7447489') {
        $('.tile.single.uberflip').css('display', 'none');
    }

}
export { test };


// WEBPACK FOOTER //
// ./scriptPartials/streamLevel.js